import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export default isWeb;
